import { Badge } from '@mantine/core';
import type { CardType } from '@taksikortti/shared';
import { t } from '../lib/strings';

const COLORS: Record<CardType, string> = {
  kertakortti: 'grape',
  taksikortti: 'teal',
  taksikortti_plus: 'indigo',
  tuntematon: 'gray',
};

export function CardTypeBadge({ type }: { type: CardType }) {
  return (
    <Badge color={COLORS[type]} variant="light" radius="sm" size="sm">
      {t.cardType[type]}
    </Badge>
  );
}
